/**
 * Format a duration in seconds to a human-readable string.
 *
 * Rules:
 * - < 120s  → "42s"
 * - < 10m   → "3.5m"
 * - < 120m  → "15m"
 * - >= 120m → "2.3h"
 */
export function formatDuration(totalSeconds: number): string {
  const rounded = Math.round(totalSeconds);

  if (rounded < 120) {
    return `${rounded}s`;
  }

  const minutes = rounded / 60;

  if (minutes < 10) {
    // One decimal place, drop trailing .0
    const formatted = minutes.toFixed(1);
    return formatted.endsWith('.0') ? `${Math.floor(minutes)}m` : `${formatted}m`;
  }

  if (minutes < 120) {
    return `${Math.round(minutes)}m`;
  }

  const hours = minutes / 60;
  const formatted = hours.toFixed(1);
  return formatted.endsWith('.0') ? `${Math.floor(hours)}h` : `${formatted}h`;
}
